import React from 'react';
import { X } from 'lucide-react';

interface Props {
  title: string;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  isLoading?: boolean;
  submitLabel?: string;
  children: React.ReactNode;
  error?: string;
}

const Modal: React.FC<Props> = ({
  title, onClose, onSubmit,
  isLoading = false, submitLabel = 'Save', children, error,
}) => (
  <div style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
    <div
      onClick={onClose}
      style={{ position: 'absolute', inset: 0, background: 'rgba(8,14,29,0.75)', backdropFilter: 'blur(4px)' }}
    />
    <div style={{
      position: 'relative', zIndex: 1, width: '100%', maxWidth: 540,
      background: 'var(--nx-surface-1)', borderRadius: 16,
      border: '1px solid var(--nx-border)',
      boxShadow: '0 24px 80px rgba(0,0,0,0.25)',
      display: 'flex', flexDirection: 'column', maxHeight: '90vh',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: '1px solid var(--nx-border)' }}>
        <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: 15, fontWeight: 700, color: 'var(--nx-text-primary)' }}>
          {title}
        </h2>
        <button
          type="button" onClick={onClose}
          style={{ width: 28, height: 28, border: 'none', background: 'var(--nx-surface-3)', borderRadius: 7, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--nx-text-muted)' }}
        >
          <X size={14} />
        </button>
      </div>
      <form
        onSubmit={onSubmit}
        style={{ padding: '20px 24px 24px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 14 }}
      >
        {error && (
          <div style={{ padding: '10px 14px', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 8, fontSize: 12, color: '#EF4444' }}>
            {error}
          </div>
        )}
        {children}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', paddingTop: 4 }}>
          <button type="button" onClick={onClose} className="nx-btn nx-btn-outline nx-btn-sm">
            Cancel
          </button>
          <button
            type="submit" disabled={isLoading}
            className="nx-btn nx-btn-primary nx-btn-sm"
            style={{ opacity: isLoading ? 0.7 : 1, cursor: isLoading ? 'not-allowed' : 'pointer' }}
          >
            {isLoading ? 'Saving…' : submitLabel}
          </button>
        </div>
      </form>
    </div>
  </div>
);

export default Modal;
